<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Localités"
      subtitle="Associations Communes - codes postaux pour la recherche d'adresse"
      autocomplete_idHistory="localities"
      autocomplete_field="localities.name || localities.contact_name || localities.contact_email || localities.contact_address"
      bdTable="localities"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      ref="locality_resource"
      defaultOrder="name"
      defaultSort="ASC"
      @edit_locality="editLocality"
      @delete_locality="deleteLocality"
    >
      <template v-slot:cell(postal_code)="data">
        <h6 v-if="data.item.postal_code" style="margin-bottom:0px">
          <b-badge
            variant="info"
            class="mr-2"
            v-for="(code, index) in data.item.postal_code.split(',')"
            :key="index"
          >
            {{ code }}
          </b-badge>
        </h6>
      </template>
      <template v-slot:cell(contact_email)="data">
        <span
          v-for="(mail, index) in data.item.contact_email.split(';')"
          :key="index"
        >
          <b-link active target="_blank" :href="'mailto:' + mail">
            {{ mail.toLowerCase() }}
          </b-link>
        </span>
      </template>
      <template v-slot:menu>
        <b-button icon title="Nouvelle localité" variant="secondary" @click="newLocality" class="mb-3"
          ><b-icon-plus-circle-fill></b-icon-plus-circle-fill></b-button
        >
      </template>
    </bd-table-list>
    <b-modal
      id="modal-modifier-locality"
      size="lg"
      title="Modifier une localité"
      hide-footer
    >
      <Locality
        @change="$refs.locality_resource.submitSearch(false)"
        @close="$bvModal.hide('modal-modifier-locality')"
        :localities_id="localities_id"
      ></Locality>
    </b-modal>
    <b-modal
      id="modal-ajouter-locality"
      size="lg"
      title="Ajouter une nouvelle localité"
      hide-footer
    >
      <Locality
        @change="$refs.locality_resource.submitSearch(false)"
        @close="$bvModal.hide('modal-ajouter-locality')"
        localities_id="new"
      ></Locality>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import localities from "@/services/localities.js";
import Locality from "@/components/Locality";
export default {
  name: "Localities",
  components: {
    BdTableList,
    Locality,
  },

  data() {
    return {
      Api: localities,
      localities_id: null,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Localités",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          event: "edit_locality",
          icon: "pencil-square",
          variant: "success"
        },
        {
          label: "Supprimer",
          action: (id) => this.deleteLocality( { ID: id}),
          icon: "x-square",
          variant: "danger",
          condition: () => this.$store.isSuperAdmin
        },
      ],
      fields: [
        {
          key: "name",
          label: "Nom",
          sortable: true,
          thStyle: { width: '10%'}
        },
        {
          key: "postal_code",
          label: "Codes postaux",
        },
        {
          key: "contact_name",
          label: "Contact",
          sortable: true,
          thStyle: { width: '10%'}
        },
        {
          key: "contact_email",
          label: "Email",
          sortable: true,
          class: 'text-truncate'
        },
        {
          key: "contact_address",
          label: "Adresse",
          class: 'text-truncate'
        },
        {
          key: "contact_phone",
          label: "Téléphone",
          sortable: true,
          
          thStyle: { width: '10%'}
        },
        {
          key: "contact_bank",
          label: "N° de compte",
          sortable: true,
          thStyle: { width: '10%'}
        },
        {
          key: "search_cost",
          label: "Coût",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return Number(value).toFixed(2) + " €";
          },
          thStyle: { width: '5%'}
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
  methods: {
    newLocality() {
      this.localities_id = "new";
      this.$bvModal.show("modal-ajouter-locality");
    },
    editLocality(payload) {
      this.localities_id = payload.ID;
      this.$bvModal.show("modal-modifier-locality");
    },
    deleteLocality(payload) {
      localities
        .delete_localities({
          localities_id: payload.ID,
        })
        .then((response) => {
          if (response.data.success) {
            this.$refs.locality_resource.submitSearch(true);
          }
        });
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>